module.exports = __webpack_public_path__ + "static/media/image5.6ca39b93.png";